"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function () {
  const lines = [{
    text: "We do not",
    indent: "md:ml-0"
  }, {
    text: "just build.",
    indent: "md:ml-16"
  }, {
    text: "We craft",
    indent: "md:-ml-8"
  }, {
    text: "a legacy.",
    indent: "md:ml-20"
  }];
  const {
    ref: eyebrowRef,
    isVisible: eyebrowVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.3
  });
  const {
    ref: line0Ref,
    isVisible: line0Visible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: line1Ref,
    isVisible: line1Visible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: line2Ref,
    isVisible: line2Visible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: line3Ref,
    isVisible: line3Visible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: leftColRef,
    isVisible: leftColVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: rightColRef,
    isVisible: rightColVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: creditRef,
    isVisible: creditVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.3
  });
  const lineRefs = [line0Ref, line1Ref, line2Ref, line3Ref];
  const lineVisibility = [line0Visible, line1Visible, line2Visible, line3Visible];
  return;
}